import React, { ReactElement, ReactNode } from "react";
import ScenariosListBottomAd from "../ScenariosListBottomAd";

const SCENARIOS_BEFORE_AD = 15;

interface Props<T> {
  items: T[];
  renderItem: (item: T) => ReactNode;
  galleryClassName?: string;
}

export default <T,>({
  items,
  renderItem,
  galleryClassName = "scenarios-gallery",
}: Props<T>): ReactElement => {
  const scenariosBeforeAd = items.slice(0, SCENARIOS_BEFORE_AD);
  const scenariosAfterAd = items.slice(SCENARIOS_BEFORE_AD);

  return (
    <>
      <div className={galleryClassName}>
        {scenariosBeforeAd.map((item) => renderItem(item))}
      </div>
      <ScenariosListBottomAd />
      {scenariosAfterAd.length > 0 && (
        <div className={galleryClassName}>
          {scenariosAfterAd.map((item) => renderItem(item))}
        </div>
      )}
    </>
  );
};
